import React from 'react';
import { Clock } from 'lucide-react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';

export const DurationSection = ({ formData, handleChange }) => {
  return (
    <div className="border-l-4 border-green-600 pl-6">
      <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Clock size={24} className="text-green-700" />
        Durée et Date/Heure de Début
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="space-y-2">
          <Label htmlFor="duration" className="text-base font-semibold">Durée souhaitée (en jours) *</Label>
          <Input
            id="duration"
            name="duration"
            type="number"
            min="1"
            max="90"
            value={formData.duration}
            onChange={handleChange}
            placeholder="Ex: 7"
            required
            className="h-12"
          />
          <p className="text-xs text-gray-500">De 1 à 90 jours</p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="startDate" className="text-base font-semibold">Date de début souhaitée *</Label>
          <Input
            id="startDate"
            name="startDate"
            type="date"
            value={formData.startDate}
            onChange={handleChange}
            required
            className="h-12"
            min={new Date().toISOString().split('T')[0]}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="startTime" className="text-base font-semibold">Heure de début de garantie *</Label>
          <Input
            id="startTime"
            name="startTime"
            type="time"
            value={formData.startTime}
            onChange={handleChange}
            required
            className="h-12"
          />
          <p className="text-xs text-gray-500">Format 24h (ex: 14:30)</p>
        </div>
      </div>
    </div>
  );
};
